import React, { useEffect, useState } from "react";
import "./personality.css";

// Posters
import anniehall from "../../movies/graciosa/anniehall.jpg";
import borat from "../../movies/graciosa/borat.jpg";
import butimacheerleader from "../../movies/graciosa/butimacheerleader.jpg";
import crazystupidlove from "../../movies/graciosa/crazystupidlove.jpg";
import drstrangelove from "../../movies/graciosa/drstrangelove.jpg";
import goodbyelenin from "../../movies/graciosa/goodbyelenin.jpg";
import palmsprings from "../../movies/graciosa/palmsprings.jpg";
import thebiglebowski from "../../movies/graciosa/thebiglebowski.jpg";
import therockyhorrorpictureshow from "../../movies/graciosa/therockyhorrorpictureshow.jpg";
import zoolander from "../../movies/graciosa/zoolander.jpg";

// Datos reales
const movies = [
  { title: "Annie Hall", image: anniehall, director: "Woody Allen", year: 1977, cast: "Woody Allen, Diane Keaton", synopsis: "La historia de una relación amorosa excéntrica y sus complicaciones, con mucho humor intelectual." },
  { title: "Borat", image: borat, director: "Larry Charles", year: 2006, cast: "Sacha Baron Cohen, Ken Davitian", synopsis: "Un periodista kazajo viaja a EEUU y provoca situaciones hilarantes mientras aprende sobre la sociedad estadounidense." },
  { title: "But I’m a Cheerleader", image: butimacheerleader, director: "Jamie Babbit", year: 1999, cast: "Natasha Lyonne, Clea DuVall", synopsis: "Una adolescente es enviada a un campamento de conversión para heterosexuales y descubre su identidad sexual." },
  { title: "Crazy, Stupid, Love", image: crazystupidlove, director: "Glenn Ficarra, John Requa", year: 2011, cast: "Steve Carell, Ryan Gosling, Julianne Moore", synopsis: "Un hombre recién divorciado aprende a ligar con la ayuda de un joven experto mientras lidia con su familia." },
  { title: "Dr. Strangelove", image: drstrangelove, director: "Stanley Kubrick", year: 1964, cast: "Peter Sellers, George C. Scott", synopsis: "Una sátira sobre la Guerra Fría y la amenaza nuclear, con un humor negro brillante." },
  { title: "Goodbye Lenin", image: goodbyelenin, director: "Wolfgang Becker", year: 2003, cast: "Daniel Brühl, Katrin Sass", synopsis: "Un joven protege a su madre de la verdad sobre la caída del Muro de Berlín de manera cómica y emotiva." },
  { title: "Palm Springs", image: palmsprings, director: "Max Barbakow", year: 2020, cast: "Andy Samberg, Cristin Milioti", synopsis: "Dos personas atrapadas en un bucle temporal encuentran romance y risas mientras repiten el mismo día." },
  { title: "The Big Lebowski", image: thebiglebowski, director: "Joel Coen, Ethan Coen", year: 1998, cast: "Jeff Bridges, John Goodman", synopsis: "Un hombre tranquilo se ve envuelto en un lío criminal absurdo lleno de personajes excéntricos." },
  { title: "The Rocky Horror Picture Show", image: therockyhorrorpictureshow, director: "Jim Sharman", year: 1975, cast: "Tim Curry, Susan Sarandon", synopsis: "Una pareja se encuentra con un extravagante científico y sus locos invitados en esta comedia musical de culto." },
  { title: "Zoolander", image: zoolander, director: "Ben Stiller", year: 2001, cast: "Ben Stiller, Owen Wilson, Will Ferrell", synopsis: "Un modelo masculino perdido y ridículo es manipulado en un complot de asesinato, lleno de sátira y humor absurdo." },
];

// ⭐⭐⭐⭐⭐ STAR SYSTEM
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient_gra">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient_gra)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Graciosa() {
  useEffect(() => window.scrollTo(0, 0), []);

  // ⭐ STORAGE SEPARADO
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMovies_Graciosa") || "{}")
  );

  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatings_Graciosa") || "{}")
  );

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMovies_Graciosa", JSON.stringify(s));

    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatings_Graciosa", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatings_Graciosa", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Graciosa</h1>
      <p>
        Entiende todo tipo de humor y es genuinamente graciosa con las formas de contar las cosas, 
        incluso gestualizándolas. Mi gesto favorito es cuando dice "es un loco esto" 
        o imita a Martín Cirio jajajaja.
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Graciosa;

